import { type FC, memo } from 'react'

import type { Resource } from '@segment/api/types/resource'

import Card from '../Card'
import CardsGroup from '../CardsGroup'
import CardsSection from '../CardsSection'

interface FeaturedResourcesProps {
  resources?: Resource[]
}

const FeaturedResources: FC<FeaturedResourcesProps> = memo(({ resources }) => {
  return (
    <CardsSection title="Featured resources">
      <CardsGroup>
        {resources?.map(({ ...props }, key) => (
          <Card key={key} {...props} />
        ))}
      </CardsGroup>
    </CardsSection>
  )
})

export default FeaturedResources
